/**
 * Swaps a video facade (snippets/video-facade.liquid) for the real YouTube
 * player on click, so nothing loads from YouTube until a shopper asks.
 * Delegated on the document because scripts inside injected fragments do not
 * run.
 *
 * Built after theme.js has run, so its wrapVideo -- which reloads an iframe
 * twice -- never sees it. See AGENTS.md, "loading="lazy" on a description
 * iframe did not defer the YouTube embed". youtube-nocookie.com matches the
 * no-JS link; video-facade.liquid says why.
 *
 * Capture phase and stopImmediatePropagation on purpose: theme.videoModal()
 * binds directly to anything matching its YouTube selector and would win,
 * playing the video in its own modal. The facade's href avoids that selector;
 * capture keeps a bare YouTube link pasted into the same description from
 * bringing the hijack back.
 */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-video-facade]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var id = link.getAttribute('data-video-id');
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = link.getAttribute('data-video-title') || 'Video';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');

    link.replaceWith(iframe);
    iframe.focus();
  }, true);
})();
